import { useCallback, useEffect, useMemo, useState } from 'react';
import { useFieldInitialData } from '../../../contexts/field-initial-data-context';
export const useServiceOptionsBase = (config)=>{
    const { fieldType, isEditor = false, postProcessOptions, customFetchLogic, onInitialDataLoaded } = config;
    const [isLoading, setIsLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const [isEmpty, setIsEmpty] = useState(false);
    const [hasInitialDataLoaded, setHasInitialDataLoaded] = useState(false);
    const initialData = useFieldInitialData(fieldType);
    const processOptions = useCallback((services)=>{
        // Standard enrichment: convert services to options
        let enrichedOptions = services.map((service)=>({
                value: service.id ?? '',
                label: service.name ?? '',
                id: service.id ?? ''
            }));
        if (postProcessOptions) {
            enrichedOptions = postProcessOptions(enrichedOptions);
        }
        return enrichedOptions;
    }, [
        postProcessOptions
    ]);
    // Handle initial data from context
    useEffect(()=>{
        if (initialData?.services) {
            const processedOptions = processOptions(initialData.services);
            setOptions(processedOptions);
            setIsEmpty(processedOptions.length === 0);
            setHasInitialDataLoaded(true);
            if (onInitialDataLoaded) {
                onInitialDataLoaded(processedOptions);
            }
        }
    }, [
        initialData,
        processOptions,
        onInitialDataLoaded
    ]);
    // Execute custom fetch logic if provided
    useEffect(()=>{
        if (customFetchLogic && !isEditor) {
            customFetchLogic();
        }
    }, [
        customFetchLogic,
        isEditor
    ]);
    // Don't render until initial data is loaded in live site
    const shouldRender = useMemo(()=>{
        return isEditor || hasInitialDataLoaded;
    }, [
        isEditor,
        hasInitialDataLoaded
    ]);
    return {
        isLoading,
        options,
        isEmpty,
        hasInitialDataLoaded,
        shouldRender,
        setIsLoading,
        setOptions,
        setIsEmpty,
        setHasInitialDataLoaded,
        processOptions
    };
};

//# sourceMappingURL=use-service-options-base.js.map